// extracted by mini-css-extract-plugin
export default {"noteTab":"style_noteTab__F-N-S"};